import React from 'react';
import { graphql } from 'react-apollo';
import { injectIntl } from 'react-intl';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';

import PaymentGatewayList from '../../../components/SiteAdmin/PaymentGatewayList/PaymentGatewayList';
import Loader from '../../../components/Common/Loader/Loader';

import getPaymentMethodsQuery from './getPaymentMethods.graphql';
import messages from '../../../locale/messages';

import s from './PaymentGateway.css';

class PaymentGateway extends React.Component {
  static defaultProps = {
    paymentMethods: {
      loading: true
    }
  }

  render() {
    const { paymentMethods: { loading, getAllPaymentMethods } } = this.props;
    const { formatMessage } = this.props.intl;
    return (
      <Loader type={"page"} show={loading}>
        <div className={s.root}>
          {!loading && <div className={s.container}>
            <div className={cx(s.heading, 'textWhite')}>
              {this.props.intl.locale === 'ar' ? 'إدارة بوابات الدفع' : formatMessage(messages.managePaymentGateWay)}
            </div>
            <div className={s.paddingRoutesSection}>
              <PaymentGatewayList getPaymentMethods={getAllPaymentMethods} />
            </div>
          </div>}
        </div>
      </Loader>
    );
  }
}

export default compose(
  injectIntl,
  withStyles(s),
  graphql(getPaymentMethodsQuery, {
    name: 'paymentMethods',
    options: {
      ssr: true,
      fetchPolicy: 'network-only'
    }
  }))(PaymentGateway);
